import { render, staticRenderFns } from "./Coinflip.vue?vue&type=template&id=b8138f60"
import script from "./Coinflip.vue?vue&type=script&lang=js"
export * from "./Coinflip.vue?vue&type=script&lang=js"
import style0 from "./Coinflip.vue?vue&type=style&index=0&id=b8138f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports